import { render, staticRenderFns } from "./KpiDeltaCard.vue?vue&type=template&id=7c73673f&scoped=true"
import script from "./KpiDeltaCard.vue?vue&type=script&lang=js"
export * from "./KpiDeltaCard.vue?vue&type=script&lang=js"
import style0 from "./KpiDeltaCard.vue?vue&type=style&index=0&id=7c73673f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c73673f",
  null
  
)

export default component.exports